import { Grid } from 'antd';

/** AntD's first breakpoint snapshot is empty; do not mount the wrong shell first. */
export function useMobileLayout(): boolean {
  const screens = Grid.useBreakpoint();
  return !(screens.md ?? (typeof window !== 'undefined' && window.innerWidth >= 768));
}
